import React from 'react';
import { colors } from 'styleguide';

interface Props {
  size?: number;
  color?: string;
}

const Flex = ({ size = 20, color = colors('neutral', 3) }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="10"
      width="10"
      height="10"
      rx="2"
      transform="rotate(90 10 0)"
      fill={color}
      stroke="none"
    />
    <rect
      x="19.25"
      y="10.75"
      width="8.5"
      height="8.5"
      rx="1.25"
      transform="rotate(90 19.25 10.75)"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M2.81616 13.6108L2.81616 16.1563C2.81616 17.2608 3.71159 18.1563 4.81616 18.1563L8.27071 18.1563"
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.909177 14.6064C1.60889 13.9174 2.7009 12.842 2.7009 12.842C2.7009 12.842 3.93341 13.9174 4.72315 14.6064"
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2726 6.36381L17.2726 3.81836C17.2726 2.71379 16.3772 1.81836 15.2726 1.81836L11.818 1.81836"
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1796 5.36817C18.4799 6.05721 17.3878 7.13259 17.3878 7.13259C17.3878 7.13259 16.1553 6.05721 15.3656 5.36816"
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Flex;
